module.exports = __webpack_public_path__ + "static/logo.a47fddf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = ./src/assets/images/logo.png
// module chunks = 2345137460201621000 7489246917808536000 10675719465928060000